/**
 * @generated SignedSource<<2569c37e1c132afc77dc848804f9f800>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type aroundHomeV2Query$variables = {
  excludeEntityIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  morningStudioQueueName: string;
};
export type aroundHomeV2Query$data = {
  readonly asia: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly business: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly comment: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly cooking: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly economy: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly hongKong: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly kPop: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly morningStudio: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly postmag: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly sport: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly tech: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly twia: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly video: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly world: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type aroundHomeV2Query = {
  response: aroundHomeV2Query$data;
  variables: aroundHomeV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeEntityIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "morningStudioQueueName"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_2"
    }
  }
],
v2 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "entityIds",
      "variableName": "excludeEntityIds"
    }
  ],
  "kind": "ObjectValue",
  "name": "exclude"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Content",
            "abstractKey": "__isContent"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "itemHomeV2AroundSCMPQueueItemsEdge"
      }
    ],
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": (v3/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_3"
    }
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_5"
    }
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_92"
    }
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_328461"
    }
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_36"
    }
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_93"
    }
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_95"
    }
  }
],
v15 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_71"
    }
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_323045"
    }
  }
],
v17 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "video_homepage_top"
    }
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "latest_recipe"
    }
  }
],
v19 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_507629"
    }
  }
],
v20 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "morningStudioQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v21 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v27 = [
  (v26/*: any*/)
],
v28 = [
  (v23/*: any*/)
],
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v31 = [
  (v4/*: any*/),
  (v25/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v5/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v5/*: any*/),
          "type": "VideoSection",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlAlias",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Sponsor",
                    "kind": "LinkedField",
                    "name": "sponsor",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v27/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": "size540x360",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "540x360"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v27/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"540x360\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "socialHeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegmentV2",
                "kind": "LinkedField",
                "name": "sectionsV2",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v28/*: any*/),
                        "type": "Section",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v28/*: any*/),
                        "type": "VideoSection",
                        "abstractKey": null
                      },
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UrlRedirect",
                    "kind": "LinkedField",
                    "name": "urlRedirect",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toUrl",
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Application",
                    "kind": "LinkedField",
                    "name": "application",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "fullSectionPath",
                        "plural": true,
                        "selections": (v31/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parentSection",
                        "storageKey": null
                      }
                    ],
                    "type": "Section",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flattenTypeIds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveArticle",
                        "kind": "LinkedField",
                        "name": "liveArticle",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v32/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaywallType",
                            "kind": "LinkedField",
                            "name": "paywallTypes",
                            "plural": true,
                            "selections": [
                              (v30/*: any*/),
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v23/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "types",
                        "storageKey": null
                      },
                      (v25/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sponsorType",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v32/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              }
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          },
          (v29/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v34 = [
  {
    "alias": null,
    "args": (v3/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v33/*: any*/),
    "storageKey": null
  },
  (v25/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aroundHomeV2Query",
    "selections": [
      {
        "alias": "hongKong",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
      },
      {
        "alias": "asia",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
      },
      {
        "alias": "world",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_5\"})"
      },
      {
        "alias": "business",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_92\"})"
      },
      {
        "alias": "economy",
        "args": (v11/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_328461\"})"
      },
      {
        "alias": "tech",
        "args": (v12/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_36\"})"
      },
      {
        "alias": "comment",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_93\"})"
      },
      {
        "alias": "sport",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_95\"})"
      },
      {
        "alias": "postmag",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_71\"})"
      },
      {
        "alias": "twia",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
      },
      {
        "alias": "video",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_homepage_top\"})"
      },
      {
        "alias": "cooking",
        "args": (v18/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"latest_recipe\"})"
      },
      {
        "alias": "kPop",
        "args": (v19/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_507629\"})"
      },
      {
        "alias": "morningStudio",
        "args": (v20/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v21/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aroundHomeV2Query",
    "selections": [
      {
        "alias": "hongKong",
        "args": (v1/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_2\"})"
      },
      {
        "alias": "asia",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
      },
      {
        "alias": "world",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_5\"})"
      },
      {
        "alias": "business",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_92\"})"
      },
      {
        "alias": "economy",
        "args": (v11/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_328461\"})"
      },
      {
        "alias": "tech",
        "args": (v12/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_36\"})"
      },
      {
        "alias": "comment",
        "args": (v13/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_93\"})"
      },
      {
        "alias": "sport",
        "args": (v14/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_95\"})"
      },
      {
        "alias": "postmag",
        "args": (v15/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_71\"})"
      },
      {
        "alias": "twia",
        "args": (v16/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
      },
      {
        "alias": "video",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_homepage_top\"})"
      },
      {
        "alias": "cooking",
        "args": (v18/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"latest_recipe\"})"
      },
      {
        "alias": "kPop",
        "args": (v19/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_507629\"})"
      },
      {
        "alias": "morningStudio",
        "args": (v20/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v21/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": null
          },
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31c5d1f53ae66ec55d79c887722b4992",
    "id": null,
    "metadata": {},
    "name": "aroundHomeV2Query",
    "operationKind": "query",
    "text": "query aroundHomeV2Query(\n  $excludeEntityIds: [String]\n  $morningStudioQueueName: String!\n) {\n  hongKong: queue(filter: {name: \"section_top_2\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  asia: queue(filter: {name: \"section_top_3\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  world: queue(filter: {name: \"section_top_5\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  business: queue(filter: {name: \"section_top_92\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  economy: queue(filter: {name: \"section_top_328461\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  tech: queue(filter: {name: \"section_top_36\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  comment: queue(filter: {name: \"section_top_93\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  sport: queue(filter: {name: \"section_top_95\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  postmag: queue(filter: {name: \"section_top_71\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  twia: queue(filter: {name: \"section_top_323045\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  video: queue(filter: {name: \"video_homepage_top\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  cooking: queue(filter: {name: \"latest_recipe\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  kPop: queue(filter: {name: \"section_top_507629\"}) {\n    items(first: 6, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n  morningStudio: queue(filter: {name: $morningStudioQueueName}) {\n    items(first: 8, exclude: {entityIds: $excludeEntityIds}) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...itemHomeV2AroundSCMPQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment contentCoverImageContent_gEdhx on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homeAroundMorningStudioPrimaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeAroundMorningStudioSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment homeAroundPrimaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment homeAroundSecondaryV2ContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_gEdhx\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment itemHomeV2AroundSCMPQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n      ...homeAroundMorningStudioPrimaryV2ContentItemContent\n      ...homeAroundMorningStudioSecondaryV2ContentItemContent\n      ...homeAroundPrimaryV2ContentItemContent\n      ...homeAroundSecondaryV2ContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "f89dab96b9c1a7b985c65cc4a10b4d32";

export default node;
